import { environment } from '../environments/environment';

export class AppConfig {
  static isLive = environment.production;

  static version: string = environment.VERSION;
  static versionCheckDelay: number = environment.versionCheckDelay;

  static sentryDsn = environment.sentryDsn;

  static paymentPortal = environment.paymentPortal;

  static ApiUrl = environment.apiUrl;

  static MyFJUrl = environment.myFJURL;

  static DcdUrl = environment.dcdUrl;

  static canRegister: boolean = environment.canRegister;

  static isTouchScreen: boolean = 'ontouchstart' in document.documentElement;

  static defaultLocale: string = 'en';

  static emailRegex: RegExp = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

  static passwordLength: number = 8;

  static mapsApiKey: string = 'AIzaSyDscqb2XFVWgCmJkZTpFQTqdsT-PfdXHdc';

  static gtmId = environment.gtmId;
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts